import { NgModule } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AgentsModule } from '../modules/agents/agents.module';
import { AppDetailsModule } from '../modules/app-details/app-details.module';
import { ContactsModule } from '../modules/contacts/contacts.module';
import { DialerModule } from '../modules/dialer/dialer.module';
import { LeadsModule } from '../modules/leads/leads.module';
import { LoanActivityModule } from '../modules/loan-activity/loan-activity.module';
import { NewApplicationModule } from '../modules/new-application/new-application.module';
import { TasksModule } from '../modules/tasks/tasks.module';
import { AlertsService } from '../services/alerts.service';
import { SharedModule } from '../shared/shared.module';
import { LayoutAdminComponent } from './admin/admin.component';
import { AdminHeaderComponent } from './admin/header/admin-header.component';
import { CallsOnLeadsOnComponent } from './admin/header/calls-on-leads-on/calls-on-leads-on.component';
import { HeaderActionsComponent } from './admin/header/header-actions/header-actions.component';
import { AppearanceToggleComponent } from './admin/header/appearance-toggle/appearance-toggle.component';
import { HeaderMenuComponent } from './admin/header/header-menu/header-menu.component';
import { MenuAimDirective } from './admin/header/header-menu/menu-aim.directive';
import { SubmenuFlyoutDirective } from './admin/header/header-menu/submenu-flyout.directive';
import { NotificationsListComponent } from './admin/header/notifications-list/notifications-list.component';
import { AcceptAndDialFreeLeadsDialogComponent } from './admin/lead-route-leads/dialogs/accept-and-dial-free-leads-dialog/accept-and-dial-free-leads-dialog.component';
import { NewLeadAssignedDialogComponent } from './admin/lead-route-leads/dialogs/new-lead-assigned-dialog/new-lead-assigned-dialog.component';
import { NewLeadReceivedDialogComponent } from './admin/lead-route-leads/dialogs/new-lead-received-dialog/new-lead-received-dialog.component';
import { WarmTransferLeadAvailableDialogComponent } from './admin/lead-route-leads/dialogs/warm-transfer-lead-available-dialog/warm-transfer-lead-available-dialog.component';
import { LeadRouteLeadsComponent } from './admin/lead-route-leads/lead-route-leads.component';
import { LayoutAuthenticationComponent } from './authentication/authentication.component';
import { HeaderClearStorageComponent } from './widgets/clear-storage.component';
import { HeaderIconComponent } from './widgets/icon.component';
import { HeaderNotifyComponent } from './widgets/notify.component';
import { HeaderSearchComponent } from './widgets/search.component';
import { HeaderTaskComponent } from './widgets/task.component';
import { HeaderUserComponent } from './widgets/user.component';
import { ConversationsModule } from '../modules/conversations/conversations.module';
import { BorrowerModule } from '../modules/borrower/borrower.module';
import { TpoLayoutComponent } from './tpo/tpo-layout/tpo-layout.component';
import { LoanUpdateConflictsModule } from 'src/app/shared/components/loan-update-conflicts/loan-update-conflicts.module';
import { TpoHeaderComponent } from './tpo/tpo-header/tpo-header.component';
import { DialNumberAndCallHistoryModule } from '../modules/dial-number-and-call-history/dial-number-and-call-history.module';
import { SelectUserModalComponent } from '../components/select-user-modal/select-user-modal.component';
import {
  LucideAngularModule,
  Grid3x3,
  PhoneCall,
  Plus,
  LayoutDashboard,
  Kanban,
  CalendarDays,
  List,
  Wrench,
  BarChart3,
  Calculator,
  Settings,
  Settings2,
  History,
  Headphones,
  Search,
  Phone,
  Bell,
  AtSign,
  MessageCircle,
  MoreHorizontal,
  Flag,
  // Submenu icons
  Building,
  Building2,
  Banknote,
  Book,
  Bot,
  SquareCheck,
  ClipboardList,
  Contact,
  Copy,
  CreditCard,
  Database,
  DollarSign,
  FileText,
  Files,
  Folder,
  Gauge,
  Handshake,
  Landmark,
  LifeBuoy,
  Mail,
  MailPlus,
  Megaphone,
  MessageSquare,
  Newspaper,
  PhoneOutgoing,
  Plug,
  Receipt,
  Route,
  ScanSearch,
  ScanText,
  ShieldCheck,
  SlidersHorizontal,
  Tags,
  TrendingUp,
  TriangleAlert,
  UserCheck,
  UserRound,
  UserRoundCog,
  Users,
  Wand,
  Webhook,
  Workflow,
  // Sub-sub menu icons (submenuLucideIconMap in header-menu.component.ts)
  Activity,
  ArrowRightLeft,
  Ban,
  Briefcase,
  Calendar,
  CircleCheck,
  CircleDot,
  ClipboardCheck,
  Download,
  FileCheck,
  FilePlus,
  FileSearch,
  FileX,
  FlaskConical,
  Funnel,
  GitFork,
  Hash,
  Image,
  KeyRound,
  Layers,
  Library,
  Link,
  ListChecks,
  ListOrdered,
  ListTodo,
  MailX,
  MapPin,
  MessageCircleQuestionMark,
  Network,
  Package,
  Paintbrush,
  Palette,
  Percent,
  PhoneForwarded,
  PhoneIncoming,
  PhoneOff,
  Play,
  Send,
  ShieldAlert,
  Shuffle,
  Tag,
  Target,
  Upload,
  UserPlus,
  SquareArrowOutUpRight,
} from 'lucide-angular';

const Components = [TpoLayoutComponent, LayoutAdminComponent];

const HeaderComponents = [
  HeaderSearchComponent,
  HeaderNotifyComponent,
  HeaderTaskComponent,
  HeaderIconComponent,
  HeaderClearStorageComponent,
  HeaderUserComponent,
  AdminHeaderComponent, HeaderMenuComponent, HeaderActionsComponent,
  AppearanceToggleComponent,
  TpoHeaderComponent
];

const Passport = [LayoutAuthenticationComponent];

@NgModule({
  imports: [
    SharedModule,
    DialerModule,
    LeadsModule,
    LoanActivityModule,
    TasksModule,
    AppDetailsModule,
    AgentsModule,
    ContactsModule,
    NewApplicationModule,
    ConversationsModule,
    BorrowerModule,
    DialNumberAndCallHistoryModule,
    LoanUpdateConflictsModule,
    LucideAngularModule.pick({
      Grid3x3,
      PhoneCall,
      Plus,
      LayoutDashboard,
      Kanban,
      CalendarDays,
      List,
      Wrench,
      BarChart3,
      Calculator,
      Settings,
      Settings2,
      History,
      Headphones,
      Search,
      Phone,
      Bell,
      AtSign,
      MessageCircle,
      MoreHorizontal,
      Flag,
      Building,
      Building2,
      Banknote,
      Book,
      Bot,
      SquareCheck,
      ClipboardList,
      Contact,
      Copy,
      CreditCard,
      Database,
      DollarSign,
      FileText,
      Files,
      Folder,
      Gauge,
      Handshake,
      Landmark,
      LifeBuoy,
      Mail,
      MailPlus,
      Megaphone,
      MessageSquare,
      Newspaper,
      PhoneOutgoing,
      Plug,
      Receipt,
      Route,
      ScanSearch,
      ScanText,
      ShieldCheck,
      SlidersHorizontal,
      Tags,
      TrendingUp,
      TriangleAlert,
      UserCheck,
      UserRound,
      UserRoundCog,
      Users,
      Wand,
      Webhook,
      Workflow,
      // Sub-sub menu icons (submenuLucideIconMap in header-menu.component.ts)
      Activity,
      ArrowRightLeft,
      Ban,
      Briefcase,
      Calendar,
      CircleCheck,
      CircleDot,
      ClipboardCheck,
      Download,
      FileCheck,
      FilePlus,
      FileSearch,
      FileX,
      FlaskConical,
      Funnel,
      GitFork,
      Hash,
      Image,
      KeyRound,
      Layers,
      Library,
      Link,
      ListChecks,
      ListOrdered,
      ListTodo,
      MailX,
      MapPin,
      MessageCircleQuestionMark,
      Network,
      Package,
      Paintbrush,
      Palette,
      Percent,
      PhoneForwarded,
      PhoneIncoming,
      PhoneOff,
      Play,
      Send,
      ShieldAlert,
      Shuffle,
      Tag,
      Target,
      Upload,
      UserPlus,
      SquareArrowOutUpRight,
    }),
  ],
  declarations: [
    ...Components, ...HeaderComponents, ...Passport,
    NotificationsListComponent,
    CallsOnLeadsOnComponent, LeadRouteLeadsComponent,
    AcceptAndDialFreeLeadsDialogComponent, WarmTransferLeadAvailableDialogComponent,
    NewLeadAssignedDialogComponent, NewLeadReceivedDialogComponent, SelectUserModalComponent,
    MenuAimDirective,
    SubmenuFlyoutDirective,
  ],
  exports: [...Components, ...HeaderComponents, ...Passport,
    NotificationsListComponent],
  providers: [AlertsService, NgbActiveModal]
})
export class LayoutModule { }
